import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarLtr, ValidarNum, ValidarNumLtr } from "../shared/Regex";

export default function NuevoConductor(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[nombre, setNombre] = useState("");
    const[tipoDoc, setTipoDoc] = useState("1");
    const[nroDoc, setNroDoc] = useState("");
    const[licencia, setLicencia] = useState("");
    //ESTADOS DE CONTENIDO
    const[selectDocumentos, setSelectDocumentos] = useState(<></>);
    //#endregion

    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(true);
    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerTiposDocumento();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(tipoDoc == "" || tipoDoc =="6" || nroDoc == "" || nombre == "" || licencia == ""){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[tipoDoc, nroDoc, nombre, licencia]);
    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerNombre = (valor) => {
        if(ValidarLtr(valor) || valor == ""){
            setNombre(valor.toUpperCase());
        }
    }

    const HandlerTipoDoc = (valor) => setTipoDoc(valor);

    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerLicencia = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setLicencia(valor.toUpperCase());
        }
    }
    //ESTADOS DE CONTENIDO
    const HandlerSelectDocumentos = (lista) => {
        setSelectDocumentos(<>{
            lista.map((item, index) => (
                item.codigo != '6' && (<option key={index} value={item.codigo}>{item.descripcion}</option>)
            ))}</>)
    }
    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => {
        setDatosCompletos(valor);
    }

    //#endregion

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    async function ObtenerTiposDocumento(){
        try{
            const response = await axios.get(URL_CONSULTA_TIPOS_DOCUMENTO, {
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            HandlerSelectDocumentos(response.data.lista);
            HandlerTipoDoc("1");

        }catch(error){
            console.log(error.message);
        }
    }
    const registrarConductor = async () => {
        try{
            let response = await axios.post(URL_INSERTAR_CONDUCTOR,{
                codigoUsuario: "",
                tipoDoc: tipoDoc,
                nroDoc: nroDoc,
                nombre: nombre,
                licencia: licencia
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.response.data);
            });
            navigate("/conductores");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/conductores'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                NUEVO CONDUCTOR
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label htmlFor="tipo-doc" className="col-form-label fw-semibold">Documento de Identidad</label>
                    <select onChange={e => HandlerTipoDoc(e.target.value)} value={tipoDoc} id="tipo-doc" type="select" className="form-select f-actor-texto" >
                        {selectDocumentos}                          
                    </select>
                    <small className="text-danger">Se admiten todos los documentos menos RUC</small>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nro-documento">N° Documento</label>
                    <input onChange={e=>HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={8} type="text" className="form-control text-uppercase" id="nro-documento" autoComplete="off"/>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nombre-conductor">Nombre Completo</label>
                    <input onChange={e=>HandlerNombre(e.target.value)} value={nombre} maxLength={120} type="text" className="form-control text-uppercase" id="nombre-conductor" autoComplete="off"/>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="licencia-conductor">N° Licencia</label>
                    <input onChange={e=>HandlerLicencia(e.target.value)} value={licencia} maxLength={20} type="text" className="form-control text-uppercase" id="licencia-conductor" autoComplete="off"/>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button disabled={!datosCompletos} onClick={registrarConductor} className="btn btn-primary">Registrar Conductor</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_CONSULTA_TIPOS_DOCUMENTO = process.env.REACT_APP_URL_TIPOS_DOCUMENTO;
const URL_INSERTAR_CONDUCTOR = process.env.REACT_APP_URL_INSERTAR_CONDUCTOR;
//#endregion